<!-- src/app/pages/merch/merch.component.html -->
<section class="merch-page">

  <!-- HERO -->
  <div class="merch-hero">
    <div class="merch-hero__content">

      <div class="merch-hero__badge">
        Campaign Store
      </div>

      <h1>Campaign Store</h1>

      <p>
        Official Lydia Christensen campaign merchandise, available while supplies last.
      </p>

    </div>
  </div>

  <div class="merch-body">
    <div class="container">

      <!-- PRODUCT GRID -->
      <div class="merch-grid">

        @for (item of items; track item.id) {

          <div
            class="merch-card"
            [class.coming-soon]="!item.purchasable"
            [attr.id]="item.id"
          >

            <!-- =========================================
                 PRODUCT IMAGE / PAYPAL IMAGE AREA
                 ========================================= -->

            <div class="merch-card__preview">

              @if (item.paypalHostedButtonId) {

                <!-- PayPal supplies the product image and checkout -->
                <div class="paypal-button-wrapper">

                  <div
                    [id]="'paypal-container-' + item.paypalHostedButtonId"
                    class="paypal-container">
                  </div>

                </div>

              } @else {

                @if (item.image.endsWith('.pdf')) {

                  <!-- PDF product preview -->
                  <iframe
                    [src]="getSafePdfUrl(item.image)"
                    [title]="item.name"
                    class="merch-card__pdf"
                    loading="lazy">
                  </iframe>

                } @else {

                  <!-- Normal image product -->
                  <img
                    [src]="item.image"
                    [alt]="item.name"
                    class="merch-card__img"
                    loading="lazy"
                  />

                }

              }

              <!-- PRODUCT BADGE -->
              @if (item.badge) {

                <span class="merch-card__badge">
                  {{ item.badge }}
                </span>

              }

            </div>

            <!-- =========================================
                 PRODUCT CONTENT
                 ========================================= -->

            <div class="merch-card__body">

              <h2 class="merch-card__name">
                {{ item.name }}
              </h2>

              <p class="merch-card__desc">
                {{ item.description }}
              </p>

              <!-- PRICE -->
              @if (
                item.price !== undefined &&
                !item.paypalHostedButtonId
              ) {

                <div class="merch-card__price">
                  ${{ item.price }}
                </div>

              }

              <!-- INVENTORY STATUS -->
              @if (
                item.purchasable &&
                item.stockLabel
              ) {

                <div class="merch-card__stock-note">

                  <strong>
                    {{ item.stockLabel }}
                  </strong>

                </div>

              }

              <!-- EMAIL ORDER FALLBACK -->
              @if (
                item.purchasable &&
                !item.paypalHostedButtonId
              ) {

                <a
                  [href]="'mailto:senator@lydialynnchristensen.com?subject=' + getOrderSubject(item)"
                  class="btn-order"
                >
                  Order via Email
                </a>

              }

              <!-- BONFIRE OPTION -->
              @if (
                item.purchasable &&
                item.bonfireUrl
              ) {

                <div class="merch-card__bonfire-option">

                  <div class="merch-card__stock-note">

                    <strong>
                      Need another size?
                    </strong>

                    <p>
                      This design is also available through our
                      print-on-demand Bonfire store in additional sizes.
                    </p>

                  </div>

                  <a
                    [href]="item.bonfireUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="btn-bonfire"
                  >
                    Buy on Bonfire →
                  </a>

                </div>

              }

              <!-- NOT CURRENTLY AVAILABLE -->
              @if (!item.purchasable) {

                <div class="merch-card__stock-note">

                  <strong>
                    Coming soon
                  </strong>

                  <p>
                    This item isn't currently available for purchase.
                  </p>

                </div>

              }

            </div>

          </div>

        }

      </div>

      <!-- =========================================
           BONFIRE CALLOUT
           ========================================= -->

      <div class="bonfire-callout">

        <div class="bonfire-callout__text">

          <span class="bonfire-callout__icon">
            👕
          </span>

          <div>

            <h3>
              Need a different size?
            </h3>

            <p>
              All four campaign shirt designs are also available
              through our print-on-demand Bonfire store in additional sizes.
            </p>

          </div>

        </div>

        <a
          href="https://www.bonfire.com/store/lydia-christensen-for-us-senate/"
          target="_blank"
          rel="noopener noreferrer"
          class="btn-bonfire"
        >
          Visit Bonfire Store →
        </a>

      </div>

      <!-- =========================================
           REUSE PROGRAM
           ========================================= -->

      <div class="reuse-section">

        <div class="reuse-section__header">

          <span class="reuse-section__icon">
            ♻️
          </span>

          <div>

            <h2>
              The Reuse Program
            </h2>

            <p class="reuse-section__sub">
              Because campaign materials shouldn't end up in a landfill.
            </p>

          </div>

        </div>

        <div class="reuse-grid">

          <div class="reuse-card">

            <div class="reuse-card__num">
              01
            </div>

            <h3>
              Return Your Yard Sign
            </h3>

            <p>
              Done with your yard sign after the election?
              Send it back and we'll clean and redistribute it
              to the next volunteer who needs one.
            </p>

          </div>

          <div class="reuse-card">

            <div class="reuse-card__num">
              02
            </div>

            <h3>
              Pass It On
            </h3>

            <p>
              Know someone who wants a sign but can't afford one?
              Forward your extra materials directly.
              Solidarity over scarcity.
            </p>

          </div>

          <div class="reuse-card">

            <div class="reuse-card__num">
              03
            </div>

            <h3>
              Get Involved
            </h3>

            <p>
              Have a printer, extra shirts, or supplies to share?
              Reach out — we'd love to coordinate with local volunteers
              to keep costs down for everyone.
            </p>

          </div>

        </div>

        <div class="reuse-cta">

          <p>
            Want to participate in the reuse program or have materials to share?
          </p>

          <a
            href="mailto:senator@lydialynnchristensen.com?subject=Reuse%20Program"
            class="btn-reuse"
          >
            Email the Campaign
          </a>

        </div>

      </div>

      <!-- =========================================
           BULK ORDERS
           ========================================= -->

      <div class="merch-bulk">

        <div>

          <h3>
            Organizing an Event?
          </h3>

          <p>
            Need a bulk order of signs or shirts for a canvassing day
            or rally? Reach out and we'll work something out.
          </p>

        </div>

        <a
          routerLink="/contact"
          class="btn-primary"
        >
          Get in Touch
        </a>

      </div>

    </div>
  </div>

</section>